import { Link } from 'react-router-dom';

const AuthFormFooter = ({ text, ...rest }) => {
  return (
    <div className="AuthFormFooter">
      <Link {...rest}>{text}</Link>
    </div>
  );
};

export default AuthFormFooter;
